module.exports = __webpack_public_path__ + "static/media/4.6f5a7f48.jpg";